import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IceButton from "../../components/Button";

export default function DialogNoSibling(props: any) {
    let {open, setOpen} = props

    return (

        <Dialog open={open} onClose={() => setOpen(false)}>
            <DialogTitle>Sibling mapping not found (</DialogTitle>

            <DialogContent>

                <DialogContentText style={{fontSize: '0.85rem'}}>
                    There are no feature-value siblings mapped yet.<br/>
                    Create a mapping for this one, to become the first.<br/>
                    All other siblings can be copied from this one.
                </DialogContentText>

            </DialogContent>

            <DialogActions>
                <IceButton type="primary" text="Close" onclick={() => setOpen(false)} />
            </DialogActions>

        </Dialog>
    );
}
